import { graphql } from "relay-runtime"

export const deMedicalReportSubscription = graphql`
  subscription deMedicalReportSubscription($patientId: ID!) {
    medicalReportAttachmentsChanged: de_medicalReportAttachmentsChanged(patientId: $patientId) {
      attachments {
        id
        url
        updatedAt
        attachmentType
        fileName
        uploadStatus
        progressNoteId
      }
      reason
    }
  }
`
